// Bootstrap de arranque: limpieza de cache local cuando operamos contra Supabase.
// Evita que datos demo residuales en localStorage interfieran con el modo Supabase.
import { dataMode } from '@/config/runtime';

const LOCAL_CRM_KEYS = [
  'conectacrm.local.db.v1',
  'conectacrm.local.auth.user',
];

export function purgeLocalCrmCacheIfNeeded(): void {
  if (dataMode !== 'supabase') return;
  if (typeof window === 'undefined') return;
  try {
    // Claves conocidas de la capa local
    LOCAL_CRM_KEYS.forEach((k) => window.localStorage.removeItem(k));
    // Barrido defensivo de cualquier clave con prefijo conectacrm.local.*
    const toRemove: string[] = [];
    for (let i = 0; i < window.localStorage.length; i++) {
      const key = window.localStorage.key(i);
      if (key && key.startsWith('conectacrm.local.')) toRemove.push(key);
    }
    toRemove.forEach((k) => window.localStorage.removeItem(k));
  } catch {
    // localStorage no disponible: nada que limpiar
  }
}
